export type ProductScreenshot = {
  src: string;
  alt: string;
  caption?: string;
};

export type Product = {
  id: string;
  slug: string;
  name: string;
  tagline: string;
  description: string;
  priceCents: number;
  currency: string;
  version: string;
  category: string;
  badge?: string;
  icon: string;
  features: string[];
  compatibility: {
    espocrm: string;
    php: string;
    notes?: string;
  };
  fileKey: string;
  downloadFilename: string;
  screenshots: ProductScreenshot[];
  heroImageUrl?: string | null;
  featured?: boolean;
  marketplaceSort?: number;
  hasPackage?: boolean;
  stripePriceId?: string | null;
};

function priceFormatter(currency = 'usd') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: (currency || 'usd').toUpperCase(),
  });
}

export function formatPrice(cents: number, currency = 'usd'): string {
  return priceFormatter(currency).format(cents / 100);
}

export function formatPriceParts(cents: number, currency = 'usd') {
  const parts = priceFormatter(currency).formatToParts(cents / 100);
  return {
    symbol: parts.filter((part) => part.type === 'currency').map((part) => part.value).join(''),
    amount: parts.filter((part) => part.type !== 'currency').map((part) => part.value).join(''),
  };
}
